import ReactMarkdown from 'react-markdown';

const PRenderer = (props) => {
  return <span className={'break-words'}>{props.children}</span>;
};

const HRRenderer = () => {
  return <hr className={'border-0'} />;
};

export const MarkdownSubjectRenderer = ({ children, ...props }) => {
  return (
    <ReactMarkdown
      allowedElements={['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'li', 'hr']}
      components={{
        p: PRenderer,
        img: () => null,
        video: () => null,
        picture: () => null,
        svg: () => null,
        h1: PRenderer,
        h2: PRenderer,
        h3: PRenderer,
        h4: PRenderer,
        h5: PRenderer,
        h6: PRenderer,
        ul: PRenderer,
        li: PRenderer,
        hr: HRRenderer,
      }}
      unwrapDisallowed={true}
      {...props}
    >
      {children}
    </ReactMarkdown>
  );
};
